import Box from "@mui/joy/Box";
import './styles/loadingBox.css'

// Source: https://uiverse.io/fanishah/funny-cow-54
const LoadingBox = () => {
    return (
        <Box class="container-box">
            <Box class="item item-1"></Box>
            <Box class="item item-2"></Box>
            <Box class="item item-3"></Box>
            <Box class="item item-4"></Box>
        </Box>
    );
}

export default LoadingBox